import { formatDateTime } from 'helpers/date/formatDateTime';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { useIntl } from 'react-intl';

export default function ModalWarningCert({ isOpen, setIsOpen, data }) {
    const intl = useIntl();

    const onHideDialogDoc = () => {
        setIsOpen(false);
    };

    const dialogFooter = (
        <React.Fragment>
            <Button
                label={intl.formatMessage({ id: 'closepopup' })}
                icon="pi pi-times"
                onClick={onHideDialogDoc}
                className="p-button p-component p-button-raised p-button-danger p-mt-2 w-xs-50 w-lg-auto p-d-xs-block p-d-lg-inline p-mx-auto"
            />
        </React.Fragment>
    );

    const genderCert = () => {
        return (
            <>
                {data?.cert?.map((item, index) => {
                    return (
                        <div>
                            {index +1}.{' '}
                            <span>{intl.formatMessage({ id: 'common.digitalSignature' })}</span>
                            <span className="label-bold text-primary"> {item?.name}</span>
                            <span> {intl.formatMessage({ id: 'common.expirationDate' })}</span>
                            <span className="label-bold text-primary"> {formatDateTime(item?.cert_end)}</span>
                        </div>
                    );
                })}
            </>
        );
    };

    return (
        <div>
            <Dialog
                visible={isOpen}
                header={intl.formatMessage({ id: 'notify' })}
                modal
                className="p-dialog-default p-dialog-lg font-size-16"
                footer={dialogFooter}
                onHide={onHideDialogDoc}
            >
                <div >
                    <div className="p-text-center">
                        <i className="pi pi-exclamation-triangle font-size-30 text-warning"></i>
                    </div>
                    <div className="p-text-center p-text-uppercase text-fw-600">{intl.formatMessage({ id: 'common.notifyCert' })}</div>
                    <div className="p-text-center">{intl.formatMessage({ id: 'common.pleaseExtendService' })}</div>
                    <br/>
                    {genderCert()}
                </div>
            </Dialog>
        </div>
    );
}
